(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pwct-birthday-bunting"] && !Shopify.designMode) return;
  try {
    (function () {
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const observed = new WeakSet();
    let frame = 0;

    function inset(el, name) {
      const value = Number.parseFloat(getComputedStyle(el).getPropertyValue(name));
      return Number.isFinite(value) ? value : 0;
    }

    function widthMode(el) {
      if (mobileQuery.matches) return el.dataset.widthMobile || 'fill';
      return el.dataset.width || 'fill';
    }

    function customPercent(el) {
      const raw = mobileQuery.matches ? el.dataset.customWidthMobile : el.dataset.customWidth;
      const value = Number.parseFloat(raw);
      return Number.isFinite(value) ? value : 100;
    }

    function contentWidth(el) {
      const row = el.querySelector('.pwct-birthday-bunting__row');
      if (!row) return 'max-content';
      const minWidth = Number.parseFloat(getComputedStyle(row).minWidth);
      if (Number.isFinite(minWidth) && minWidth > 0) return Math.round(minWidth) + 'px';
      return 'max-content';
    }

    function px(value) {
      return Math.round(value) + 'px';
    }

    function write(el, prop, value) {
      if (el.style[prop] !== value) el.style[prop] = value;
    }

    function place(el) {
      const anchor = el.dataset.buntingAnchor;
      if (!anchor || anchor === 'flow') return;

      const section = el.closest('.shopify-section') || el.closest('.section');
      if (!section) return;

      if (getComputedStyle(section).position === 'static') section.style.position = 'relative';

      const parent = el.offsetParent;
      if (!parent) return;

      const sectionRect = section.getBoundingClientRect();
      const parentRect = parent.getBoundingClientRect();
      if (sectionRect.width === 0) return;

      const topInset = inset(el, '--bunting-inset-top');
      const rightInset = inset(el, '--bunting-inset-right');
      const bottomInset = inset(el, '--bunting-inset-bottom');
      const leftInset = inset(el, '--bunting-inset-left');
      const isEdge = anchor === 'top' || anchor === 'bottom';
      const isTop = anchor === 'top' || anchor.indexOf('top-') === 0;
      const isRight = !isEdge && anchor.endsWith('right');
      const mode = widthMode(el);
      const span = isEdge || mode === 'fill';

      const pinLeft = span || !isRight;

      write(el, 'top', isTop ? px(sectionRect.top - parentRect.top + topInset) : 'auto');
      write(el, 'bottom', isTop ? 'auto' : px(parentRect.bottom - sectionRect.bottom + bottomInset));
      write(el, 'left', pinLeft ? px(sectionRect.left - parentRect.left + leftInset) : 'auto');
      write(el, 'right', pinLeft ? 'auto' : px(parentRect.right - sectionRect.right + rightInset));

      if (span) {
        write(el, 'width', px(Math.max(0, sectionRect.width - leftInset - rightInset)));
      } else if (mode === 'custom') {
        write(el, 'width', px(Math.max(0, (sectionRect.width * customPercent(el)) / 100)));
      } else {
        write(el, 'width', contentWidth(el));
      }

      if (!observed.has(section) && typeof ResizeObserver !== 'undefined') {
        observed.add(section);
        const observer = new ResizeObserver(function () {
          schedule(section);
        });
        observer.observe(section);
      }
    }

    function placeAll(root) {
      const scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('[data-bunting-anchor]').forEach(place);
    }

    function schedule(root) {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(function () {
        placeAll(root);
      });
    }

    function start() {
      schedule(document);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();

    window.addEventListener('resize', start);
    document.addEventListener('shopify:section:load', function (event) {
      schedule(event.target);
    });
    if (typeof mobileQuery.addEventListener === 'function') mobileQuery.addEventListener('change', start);
  })();
  } catch(e) { console.error(e); }
})();

})();
